<template>
  <div >
    <loader v-if="isLoading"></loader>
    <div v-else class="ym-hide-content">
      <div class="wrapper">
        <div class="header">
          <div class="header__about-company">
            <img class="logo" src="img/logo.png">
            <div class="header__company-info">
              <p><strong>ООО МКК «ФИНМОЛЛ»</strong></p>
              <p>630112, г. Новосибирск, <br> ул. Фрунзе, д. 242 пом. 406</p>
              <p>тел: 8 800-600-99-90</p>
              <p><b>Свидетельство МФО:</b></p>
              <p>65140355005541</p>
              <p><a href="http://www.finmoll.ru">http://www.finmoll.ru/</a></p>
              <p><b>Служба контроля качества:</b></p>
              <p>8 800-600-19-94</p>
              <p>help@msk.finmoll.com</p>
              <div class="header__inputs">
                <div>
                  <input type="checkbox"  checked disabled>
                  <label>ПДЛ</label>
                </div>

              </div>
            </div>
          </div>
          <div class="header__right">
            <div class="credit-costs">
              <div class="credit-cost">
                <div>
                  <p class="credit-cost__title"><b>Полная стоимость займа:
                    {{dg.extended.pdlGetSelectedDeal.PercentageRate}}%</b></p>
                  <p>{{dg.extended.pdlGetSelectedDeal.PercentageRate | intToWords}}  процентов годовых</p>
                </div>
              </div>
              <div class="credit-cost">
                <div>
                  <p class="credit-cost__title"><b>Полная стоимость займа:{{dg.extended.pdlGetSelectedDeal.OutPayments}} рублей</b></p>
                  <p>{{dg.extended.pdlGetSelectedDeal.OutPayments | intToWordsMoney}}</p>
                </div>
              </div>
            </div>
          </div>

        </div>

        <section class="section">
          <p><strong>РАЗДЕЛ 1. ИНДИВИДУАЛЬНЫЕ УСЛОВИЯ ДОГОВОРА ПОТРЕБИТЕЛЬСКОГО ЗАЙМА № 0{{dg.extended.DemandId}}</strong></p>
          <table class="conditions">
            <tr>
              <td colspan="3" style="text-align: start">По договору потребительского займа, срок возврата потребительского займа по которому на момент его заключения не превышает одного года, не допускается начисление процентов, неустойки (штрафа, пени), иных мер ответственности по договору потребительского займа, а также платежей за оказываемые услуги (выполняемые работы, реализуемые товары) кредитором заемщику за отдельную плату по договору потребительского займа, после того, как сумма начисленных процентов, неустойки (штрафа, пени), иных мер ответственности по договору потребительского займа, а также платежей за оказываемые услуги (выполняемые работы, реализуемые товары) кредитором заемщику за отдельную плату по договору потребительского займа, достигнет 130 процентов от суммы предоставленного потребительского займа. После возникновения просрочки исполнения обязательства заемщика - физического лица по возврату суммы займа и (или) уплате причитающихся процентов микрофинансовая организация по договору потребительского займа, срок возврата потребительского займа по которому не превышает один год, вправе начислять заемщику - физическому лицу неустойку (штрафы, пени) и иные меры ответственности только на не погашенную заемщиком часть суммы основного долга.
              </td>
            </tr>
            <tr>
              <th>№</th>
              <th>Условие</th>
              <th>Содержание условия</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Сумма кредита (займа) или лимит кредитования и порядок его изменения</td>
              <td>{{dg.extended.pdlGetSelectedDeal.Amount}} рублей 00 копеек</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Срок действия договора, срок возврата займа</td>
              <td> Срок действия договора потребительского займа: с момента заключения до полного выполнения сторонами своих обязательств. <br><br>
                Срок возврата суммы займа: {{dg.extended.pdlGetSelectedDeal.loanPeriod}} дней.</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Валюта, в которой предоставляется заём</td>
              <td>Рубль</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Процентная ставка (процентные ставки) в
                процентах годовых, а при применении переменной
                процентной ставки - порядок ее определения,
                соответствующий требованиям Федерального
                закона от 21 декабря 2013 года N 353-ФЗ "О
                потребительском кредите (займе)", ее значение на
                дату предоставления заемщику индивидуальных
                условий
              </td>
              <td>
                <div >
                  {{dg.extended.pdlGetSelectedDeal.PercentageRate}} процентов в год
                </div>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>Порядок определения курса иностранной валюты при переводе денежных средств кредитором третьему лицу,
                указанному Заемщиком
              </td>
              <td>Не применимо</td>
            </tr>
            <tr>
              <td>5.1</td>
              <td>Указание на изменение суммы расходов заемщика при увеличении используемой в договоре потребительского
                кредита (займа) переменной процентной ставки потребительского кредита (займа) на один процентный пункт
                начиная со второго очередного платежа на ближайшую дату после предполагаемой даты заключения договора
              </td>
              <td>Не применимо</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Количество, размер и периодичность (сроки) платежей Заемщика по договору или порядок определения этих
                платежей</td>
              <td>Один платеж в конце срока займа на сумму {{dg.extended.pdlGetSelectedDeal.OutPayments}} руб.
                {{dg.extended.pdlGetSelectedDeal.OutPayments | intToWordsMoney}}
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>Порядок изменения количества, размера и периодичности (сроков) платежей Заемщика при частичном досрочном
                возврате займа
              </td>
              <td>При частичном досрочном возврате займа периодичность платежей по Договору займа не изменяется. Изменяется размер платежа в зависимости от суммы частичного досрочного погашения. Предоставляется новый график платежей. В случае если при частичном досрочном возврате происходит изменение полной стоимости займа, Кредитор предоставляет Заемщику новое значение полной стоимости займа.
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>Способы исполнения Заемщиком обязательств по договору по месту нахождения Заемщика</td>
              <td>В безналичном порядке через: кредитные организации, Операторов платежных систем, находящихся в
                населенном
                пункте по месту нахождения Заемщика, в т.ч. указанных в п.8.1. Индивидуальных условий.
              </td>
            </tr>
            <tr>
              <td>8.1</td>
              <td>Бесплатный способ исполнения Заемщиком обязательств по договору</td>
              <td>Оплата в магазинах kari посредством сервиса Золотая корона
                в сети магазинов Евросеть, сети магазинов Билайн, сети магазинов МТС
                в сети пунктов обслуживания сервиса «Золотая корона – Погашение кредитов»
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>Обязанность Заемщика заключить иные договоры</td>
              <td>Не применимо</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Обязанность Заемщика по предоставлению обеспечения исполнения обязательств по договору и требования к
                такому обеспечению
              </td>
              <td>Не применимо</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Цели использования Заемщиком потребительского кредита (займа)</td>
              <td>Не применимо</td>
            </tr>
            <tr>
              <td>12</td>
              <td>Ответственность Заемщика за ненадлежащее исполнение условий договора, размер неустойки (штрафа, пени)
                или
                порядок их определения
              </td>
              <td>При ненадлежащем исполнении условий договора займа, на просроченный остаток основного долга ежедневно начисляются пени в размере 20% годовых за соответствующий период нарушения обязательств.</td>
            </tr>
            <tr>
              <td>13</td>
              <td>Условие об уступке Кредитором третьим лицам прав (требований) по договору</td>
              <td>С правом Кредитора уступить третьим лицам права (требования) по договору<br>

                <input type="checkbox"  v-model="dg.extended.IS_ASSIGNMENT_RIGHT" :true-value="'1'" :false-value="'0'"/>
                согласен <br>

                <input type="checkbox"  v-model="dg.extended.IS_ASSIGNMENT_RIGHT" :true-value="'0'" :false-value="'1'"/>
                не
                согласен
                <!--            <signature-->
                <!--              :LastName="dg.ClLastName"-->
                <!--              :FirstName="dg.ClFirstName"-->
                <!--              :MiddleName="dg.ClMiddleName"-->
                <!--              :DemandDate="dg.DemandDate"-->
                <!--              :DataConfirm="dg.DataConfirm"-->
                <!--            ></signature>-->
              </td>
            </tr>
            <tr>
              <td colspan="3" style="text-align: start">
                <!--            <signature-->
                <!--              :LastName="dg.ClLastName"-->
                <!--              :FirstName="dg.ClFirstName"-->
                <!--              :MiddleName="dg.ClMiddleName"-->
                <!--              :DemandDate="dg.DemandDate"-->
                <!--              :DataConfirm="dg.DataConfirm"-->
                <!--            ></signature>-->
              </td>
            </tr>
          </table>
          <br/>
          <br/>
          <p class="pagebreak"><strong>РАЗДЕЛ 1. ИНДИВИДУАЛЬНЫЕ УСЛОВИЯ ДОГОВОРА ПОТРЕБИТЕЛЬСКОГО ЗАЙМА № 0{{dg.extended.DemandId}}}</strong></p>
          <table class="conditions">
            <tr>
              <th>№</th>
              <th>Условие</th>
              <th>Содержание условия</th>
            </tr>
            <tr>
              <td>14</td>
              <td>Согласие Заемщика с Общими условиями договора</td>
              <td>Общие условия предоставления займов ООО МКК «ФИНМОЛЛ» мне известны, понятны и принимаются мной в полном
                объеме
<!--                <signature-->
<!--                    :LastName="dg.LAST_NAME"-->
<!--                    :FirstName="dg.FIRST_NAME"-->
<!--                    :MiddleName="dg.SECOND_NAME"-->
<!--                    :DemandDate="dg.DemandDate"-->
<!--                    :DataConfirm="dg.DataConfirm"-->
<!--                ></signature>-->
              </td>
            </tr>
            <tr>
              <td>15</td>
              <td>Оказываемые услуги (выполняемые работы, реализуемые товары) Кредитором Заемщику за отдельную плату и необходимые для заключения договора, их цена или порядок ее определения, а также согласие заемщика на их оказание, выполнение, приобретение.
              </td>
              <td>Не применимо</td>
            </tr>
            <tr>
              <td>16</td>
              <td>Способ обмена информацией между Кредитором и Заемщиком</td>
              <td>Кредитор вправе направлять уведомления в адрес Заемщика одним из следующих способов по своему
                усмотрению:<br />
                1. Направление текстового сообщения на номер мобильного телефона, указанного Заемщиком в настоящем
                договоре;<br />
                2. Направление письменного уведомления на адрес регистрации, указанный Заемщиком в настоящем договоре
                (курьером или почтовой службой);<br />
                3. Направление сообщения на адрес электронной почты (e-mail), указанный Заемщиком в настоящем
                договоре;<br>
                4. Голосовое информирование на номер мобильного телефона, указанного Заемщиком в настоящем договоре.<br>
                Кредитор вправе использовать любой из указанных способов уведомления Заемщика.
                Направление информации одним или несколькими из указанных способов является надлежащим исполнением
                обязательств Кредитора по доведению информации до сведения Заемщика. Заемщик вправе направить сообщение /
                заявление в адрес Кредитора по месту нахождения Кредитора, указанному в настоящем Договоре займа.

              </td>
            </tr>
            <tr>
              <td>17</td>
              <td>Согласие Заемщика на обработку персональных данных</td>
              <td>Я, нижеподписавшийся (далее – Заемщик), персональные данные которого указаны в Разделе 2 «Информация о
                заемщике» Договора займа, даю свое согласие на заключение между Мной и ООО МКК «ФИНМОЛЛ» (адрес
                местонахождения: 630112, г. Новосибирск, ул. Фрунзе, д. 242 пом. 406, Свидетельство МФО: 65140355005541),
                именуемым в дальнейшем «Кредитор», Договора займа на указанных условиях. А также предоставляю Кредитору и
                иным третьим лицам свое согласие на обработку моих персональных данных, на условиях, определенных п. 1.6.
                Общих условий Договора Займа.
<!--                <signature-->
<!--                    :LastName="dg.LAST_NAME"-->
<!--                    :FirstName="dg.FIRST_NAME"-->
<!--                    :MiddleName="dg.SECOND_NAME"-->
<!--                    :DemandDate="dg.DemandDate"-->
<!--                    :DataConfirm="dg.DataConfirm"-->
<!--                ></signature>-->

              </td>
            </tr>

            <tr>
              <td>18</td>
              <td>Прочие условия</td>
              <td>Настоящие Индивидуальные условия Договора займа не могут быть изменены Кредитором в одностороннем
                порядке
                в течение 5 (Пяти) рабочих дней со дня их получения Заемщиком.Подписывая Договор займа, подтверждаю, что
                вся
                информация, указанная мною, является полной и достоверной. Общие условия предоставления и обслуживания
                займов ООО МКК «ФИНМОЛЛ» мне предоставлены для ознакомления, мной прочитаны, понятны.Подписывая Договор
                займа, я предоставляю Кредитору право на предоставление в мой адрес электронного средства платежа, по
                адресу, указанному мной в п. 2.3. Раздела 2 настоящих Индивидуальных условий Договора займа.
              </td>
            </tr>
            <tr>
              <td colspan="3" style="text-align: start">
                <!--            <signature-->
                <!--              :LastName="dg.ClLastName"-->
                <!--              :FirstName="dg.ClFirstName"-->
                <!--              :MiddleName="dg.ClMiddleName"-->
                <!--              :DemandDate="dg.DemandDate"-->
                <!--              :DataConfirm="dg.DataConfirm"-->
                <!--            ></signature>-->
              </td>
            </tr>
          </table>
        </section>

        <section class="section">
          <p><strong>РАЗДЕЛ 2. ИНФОРМАЦИЯ О ЗАЕМЩИКЕ </strong></p>
          <table class="user-info-table">
            <tr>
              <td>
                <div class="user-info__fio">
                  <p><strong> 2.1 Заёмщик:</strong></p>
                  <p>Фамилия: {{dg.LAST_NAME}}</p>
                  <p>Имя: {{dg.FIRST_NAME}}</p>
                  <p>Отчество: {{dg.SECOND_NAME}}</p>
                </div>
              </td>
              <td>
                <div class="user-info__passport">
                  <p><strong>2.2 Паспорт</strong></p>
                  <p>Серия {{dg.PASSPORT_SERIES}} номер {{dg.PASSPORT_NUMBER}}</p>
                  <p>Код подразделения {{dg.PASSPORT_DEP_CODE}}</p>
                  <p>Дата выдачи {{dg.PASSPORT_DATE}} г.</p>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="user-info__registration">
                  <p><strong>2.3 Регистрация</strong></p>
                  <p>{{dg.REGISTRATION_ADDRESS}}</p>
                  <p><strong>2.4 Фактический адрес проживания</strong></p>
                  <p>{{dg.RESIDENTIAL_ADDRESS}}</p>
                </div>
              </td>
              <td>
                <div class="user-info__other">
                  <p><strong>2.5 СНИЛС </strong>{{dg.extended.SNILS}}</p>
                  <p><strong>2.6 Моб. Тел. </strong>{{dg.PHONE | humanViewPhone}}</p>
                  <p><strong>2.7 E-mail </strong>{{dg.EMAIL}}</p>
                </div>
              </td>
            </tr>
          </table>
          <p>Настоящий договор микрозайма (далее – Договор займа) заключен на условиях, определенных в Разделе 1
            «Индивидуальные условия договора потребительского займа», а также Общими условиями предоставления и
            обслуживания
            займов ООО МКК «ФИНМОЛЛ», являющимися в совокупности Договором займа</p>
        </section>
        <section class="section">
          <p><strong>РАЗДЕЛ 3. ПЛАТЕЖНЫЕ РЕКВИЗИТЫ </strong></p>
          <table class="user-info-table">
            <p><strong>ПЛАТЕЖНЫЕ РЕКВИЗИТЫ </strong></p>


            <div v-if="dg.extended.PAYMENT_TYPE === 'TinkoffE2C'">
              <p>Банковская карта: {{dg.extended.tinkoffE2C_cardSelected.pan}}</p>
            </div>
            <div v-if="dg.extended.PAYMENT_TYPE === 'TinkoffA2C'">
              <p>СБП: {{dg.extended.tinkoffA2C_bankSelected.memberNameRus}}</p>
            </div>
          </table>
          <!--      <signature-->
          <!--        :LastName="dg.ClLastName"-->
          <!--        :FirstName="dg.ClFirstName"-->
          <!--        :MiddleName="dg.ClMiddleName"-->
          <!--        :DemandDate="dg.DemandDate"-->
          <!--        :DataConfirm="dg.DataConfirm"-->
          <!--      ></signature>-->
        </section>
        <section class="section" v-if="dg.extended.LOAN_WITH_INSURANCE === 1">
          <p>
             <strong>РАЗДЕЛ 3.1 ОПЛАТА ТОВАРОВ/УСЛУГ ТРЕТЬЕГО ЛИЦА </strong>
          </p>

           <div>
            <input type="checkbox" checked disabled>
            <p>Прошу перечислить часть займа в размере {{pdlBox}} рублей, в соответствии с Заявлением
              о предоставлении дополнительных услуг.</p>
           </div>

        </section>

        <section class="section flex ft">
          <div>
            <p><strong>Экземпляр Индивидуальных условий мною получен</strong></p>
          </div>
          <div class="qr">
            <img src="https://lk.msk.finmoll.com/img/QR-code_url_27_Sep_2021_15-5-20.png" alt="">
          </div>
        </section>
      </div>
    </div>
    <pdn v-if="isPdn" class="pagebreak"></pdn>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "docIU",
    data(){
      return {
        isLoading:true,
        demand:'',
        dg:{
          extended:{
            pdlGetSelectedDeal:{
              PercentageRate:''
            },
            LOAN_WITH_INSURANCE:'',
            PAYMENT_TYPE:'',
            IS_ASSIGNMENT_RIGHT:undefined
          }
        },
        pesentageView:'single',
        isPdn:false,
      }
    },
    components:{
      // signature: () => import('@/components/other/signature'),
      loader :() => import('@/views/pdlloan/uiLoader'),
      pdn:()=>import('@/views/pdlloan/docPDN_PDL'),
    },
    watch:{
      'dg.extended.IS_ASSIGNMENT_RIGHT': function (newValue, oldValue){
        if(oldValue !== undefined) {
          console.log(this)
          axios.post(process.env.VUE_APP_URL_TRACE, [{
            session_id: this.$route.params.session_id,
            token: this.$route.params.token,
            action:165,
            refs:'IS_ASSIGNMENT_RIGHT',
            value:newValue
          }]);
        }
      },
    },
    computed:{
      pdlBox(){
        let out = 0;
        if(this.dg.extended.LOAN_WITH_INSURANCE == 1){
          let step = 1000;
          let boxSumm = 0;
          let exitValue = 15000;
          while(step < exitValue){
            boxSumm = step * 0.1;
            if(step + boxSumm === parseInt(this.dg.extended.pdlGetSelectedDeal.Amount, 10)) {
              out = boxSumm;
              step = exitValue
            }
            step+=1000;
          }
        }
        return out;
      },
    },
    methods:{
      reloadIu(){
        this.loadIU();
        setTimeout(()=>{
          this.loadIU();
        },3000)
      },
      getPdn(){
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_PDN_CHECK,
          data: {
            token: this.$route.params.token,
          }
        }).then((res) => {
          console.log(res)
          if (res.data?.result === '') {
            //если случилась хуйня показывать пдн, Даниил
            this.isPdn = true;
          }
          if (res.data?.result?.Value === null) {
            //если случилась хуйня показывать пдн, Даниил
            this.isPdn = true;
          } else if (res.data?.result?.Value) {
            this.isPdn = true;
          } else {
            this.isPdn = false;
          }
        }).catch((e) => {
          console.log(e)
          //если случилась хуйня показывать пдн, Даниил
          this.isPdn = true;
        });
      },
      loadIU(){
        try {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_LOAN,
            data: {
              action:'getIU',
              token:this.$route.params.token,
              session_id:this.$route.params.session_id
            }
          }).then(res=>{
            try {
              if (res.data.result.extended !== undefined){
                res.data.result.extended = JSON.parse(res.data.result.extended);
                // if ( res.data.result.extended.pdlGetSelectedDeal !== undefined){
                //   res.data.result.extended.pdlGetSelectedDeal = JSON.parse(res.data.result.extended.pdlGetSelectedDeal);
                // }
                this.isLoading = false;
              }
            }catch (e) {
              console.log(e)
            }
            this.dg = res.data.result;

          }).catch(res=>{
            console.log(res)
            alert('Ошибка формирования иу sid='+this.$route.params.session_id)
          });
        } catch (e) {
          alert('Ошибка формирования иу sid='+this.$route.params.session_id)
        }
        // try {
        //   this.getPdn();
        // }
        // catch(e){
        //   console.log(e)
        // }
      }
    },
    mounted(){
      this.loadIU();
      this.demand = localStorage.getItem('DemandId');
    },
    created(){
      window.addEventListener('focus',this.reloadIu)
    }
  }
</script>

<style scoped>
  table{width: 100%;border-collapse: collapse}

  td{padding: 2px;}

  .flex {
    display: flex;
  }

  .ft{justify-content: space-between;align-items: flex-start}


  .wrapper {
    width: 1200px;margin: auto;
    padding: 10px;
    font-size: 10px;
    line-height: 1.5;
  }

  .section {
    margin-bottom: 30px;
  }

  .section p {
    margin-bottom: 5px;
  }

  .logo {
    width: 200px;
    margin-bottom: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  .header__company-info {
    min-width: 180px;
    font-size: 10px;
    padding-left: 15px;
  }

  .header__right {
    width: 70%;
    padding-left: 30px;
  }

  .header__company-info p {
    margin-bottom: 5px;
  }

  .header__company-info p {
    margin-bottom: 5px;
  }

  .header__inputs {
    margin-top: 10px;
  }

  .header__inputs label {
    margin-left: 5px;
  }

  .credit-costs {
    display: flex;
    justify-content: space-between;
  }

  .credit-cost {
    width: 280px;
    height: 280px;
    padding: 10px;
    border: 1px solid black;
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-transform: uppercase;
  }

  .credit-cost__title {
    margin-bottom: 10px;
  }

  .agent {
    width: 100%;
    border: 1px solid black;

  }

  .agent__top {
    display: flex;
    align-items: center;
    border-bottom: 1px solid black;
    padding: 10px 5px;
    margin-bottom: 10px;
  }

  .agent__bottom {
    align-items: center;
    padding: 10px 5px;
  }

  .agent__top p:first-child {
    margin-right: 100px;
  }




  .main p {
    margin-bottom: 5px;
  }

  .conditions {
    margin-bottom: 20px;
  }

  table,
  tr,
  th,
  td {
    border-collapse: collapse;
    border: 1px solid black;
    vertical-align: top;
  }

  td:nth-child(3) {
    vertical-align: middle;
  }

  .conditions td:first-child {
    text-align: center;
  }

  .conditions table td:first-child {
    min-width: 100px;
  }

  .conditions td:nth-child(2) {
    min-width: 300px;
  }

  .conditions td:nth-child(3) {
    min-width: 300px;
  }

  .conditions th {
    background-color: rgb(216, 212, 212);
  }

  .signature {
    height: 40px;
    margin-top: 10px;
  }



  p {
    margin-bottom: 0;
  }


  .user-info-table {
    width: 100%;
  }

  .qr {
    text-align: end;
  }

  .qr img {
    width: 130px;
  }



  @media (min-width: 1200px) {
    .wrapper {
      font-size: 16px;
    }

    .header__company-info {
      font-size: 16px;
    }
  }

  @media only print {
      .pagebreak { page-break-before: always; } /* page-break-after works, as well */

    .wrapper{width: auto}
    .section { margin-bottom: 30px; padding: 0;}

    .section p {
      margin-bottom: 0px;
    }

    .header__right {
      width: 500px
    }

    .credit-cost {
      height: 150px;
      width: 200px;
    }

    .agent__top {
      padding: 2px;
      margin-bottom: 0px;
    }

    .agent__bottom {
      padding: 2px
    }


    .signature {
      margin-top: 10px;
    }

    table {
      margin: 0
    }

    .header {
      margin-bottom: 10px;
    }

    .wrapper {
      font-size: 9px;
      line-height: 1.1;
    }

    .logo {
      width: 150px
    }
    .qr img {
      width: 100px;
    }

  }


  @media only screen and (min-width: 320px) and (max-width: 780px) {
    .wrapper {
      font-size: 16px;
    }

    .credit-cost {
      width: 50%;
      padding: 5px;
      min-height:300px;
    }

    .header__company-info {
      font-size: 16px;
    }
  }

</style>
